import { OctNumberField } from '@oceantech/oceantech-ui';
import clsx from 'clsx';
import { useState } from 'react';
import EditableCell from '../../../../phan-he-kham-benh/modals/modal-chi-dinh-dich-vu/cells/EditableCell';
import { formatMoney } from '../../../../utils/FormatUtils';
import { PaymentCellEditProps } from './types';

const PaymentPtPercentCell = ({
	rowData,
	onCellEdit,
	rowIndex,
	editable,
	cellIndex,
	selectedCell,
	setSelectedCell,
}: PaymentCellEditProps) => {
	const [inputValue, setInputValue] = useState(rowData?.paymentPtPercentClone);

	const CELL_ID = `${rowData.id}${cellIndex}`;
	const textValue =
		formatMoney(rowData?.paymentPtPercentClone) !== '0'
			? formatMoney(rowData?.paymentPtPercentClone)
			: '';
	
	return (
		<EditableCell
			disabled={!editable}
			className={clsx({
				'focus-cell': CELL_ID === selectedCell,
				'min-h-28': rowData?.id,
			})}
			textValue={textValue}
			textClassName={clsx('text-center fw-normal spaces line-height-28', {
				'text-danger': rowData?.isCancel,
			})}
			editComponent={() => {
				return (
					<OctNumberField
						className='input editable-cell'
						inputClassName="w-100 text-end"
						name="paymentPtPercentClone"
						min={0}
						allowNegative={false}
						placeholder="%"
						value={inputValue}
						onChange={(value) => {
							setInputValue(value);
						}}
						onBlur={() => {
							setSelectedCell(CELL_ID);
							if (inputValue !== rowData?.paymentPtPercentClone) {
								onCellEdit(rowData, inputValue, rowIndex, 'paymentPtPercentClone');
							}
						}}
					/>
				);
			}}
		/>
	);
};

export default PaymentPtPercentCell;
